import React, { useState } from 'react'
import axios from 'axios';
import '../../Partner.css';
import banner from '../../images/banners/collect.jpg'
import { Helmet } from 'react-helmet';
export default function Partners() {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [formdata, setformdata] = useState({
        company_name:'',
        license_no:'',
        activities:'',
        transport_license:'yes',
        contact_person:'',
        contact_no:'',
        address:'',
        city:'',
        country:'',
        email:''
    })
   
    const [resultmsg, setresultmsg] = useState('')
    const [errorsts, seterrorsts] = useState(0)

    const API_PATH=`${SERVER_URL}partner_contact.php`;
    function handleFormSubmit(event){
        event.preventDefault();
        console.log(formdata);
      
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formdata.email))
        {
            
        axios({
            method: 'post',
            url: `${API_PATH}`,
            data: formdata
          })
          .then((res)=>{
              //setresultmsg(res.data.sent)
              console.log(res.data.message)
              setresultmsg(res.data.message);
              //console.log(resultmsg)
          })
            // .then(res => {
            //   this.setState({
            //     mailSent: res.data.sent
            //   })
            // })
            .catch(error => console.log(error.message));
        }else{
            setresultmsg('Please enter a valid email address');
        }
    }

  
    return (
        
        <div className="partner">
           <Helmet>
        <title>Time Express | Become A Partner</title>
      </Helmet>
            <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
           <div className="container"><div className="row">
                    <div className="col-md-12 col-sm-12 your_business text-center">
                        <div className="business_content">
                        <h1 className="mainhead">Become a Partner</h1>
                        </div>
                    </div>
                </div>
                </div>
            </section>

            <div className="pages_content">
            <div className="container">
            <div className="row">
            <div id="primary" className="content-area" style={{float: 'left', width: '100%'}}>
            <main id="main" className="site-main" role="main">
           <div className="entry-content">
           <div className="become_driver">
            As a partner, we leverage your under-utilized vehicles to ensure they are used 24/7. If you are using your company transport van for 2 hours a day, we will ensure your vehicle is operating the remaining 6 hours during that day.<p>&nbsp;</p>
            <p>You will be given priority status for collecting and delivering parcels on behalf of Time Express in your selected geographical area, we will jointly partner and work with you to grow volumes and increase the utilization of your vehicles in your area to increase your earnings.</p><p>Behind The Wheel: They are people like you, going your way.</p><p>What makes the Time Express experience truly great are the people behind the wheel. Our partners drive their own cars and manage their own fleet of vehicles – on their own schedule – in cities they chose.</p>
            <h4>HOW IT WORKS?</h4>
            <p>Time Express Parcels Delivery LLC does deliveries of parcels door to door around the clock; as a committed partner, you join our parcel delivery community in maximizing the capacity of your transport vehicles to collect parcels on our behalf and expand your business income.</p>
            <h4>OUR PARTNERSHIP</h4>
            <p>How do we work together as partners?
            <br />As partners, we each have responsibilities to make the business work. Time Express will bring and negotiate commercial agreements with end-users. Through our agreement, you will become our appointed partner to cover certain areas, territories, or destinations. As we increase volumes and parcels in your local area, your transport vehicles become better utilized generating for your a new source of revenue.</p><h4>WHY PARTNER WITH US?</h4><p>We provide advanced technology, tools, systems, infrastructure, networks, as well as the commercial drive to ensure your business grows. By partnering with Time Express, your focus is on operations and ensuring parcels to businesses and residential customers are delivered on time every time.</p><h4>REWARDS</h4><p>What’s in it for you?</p><p>As a licensed partner, you benefit from a new stream of income for your business by maximizing the utilization of your transport fleet.</p><p>Earn more money as your assets are better utilized and increase your business profits.</p><h4>HOW WE COLLABORATE?</h4><p>We expect a mutual commitment to ensure our levels of service are always the best, and our customers are given the top priority. You need to ensure that the parcels we put at your disposition to distribute in your selected area are delivered on time and your drivers are using our technology to track and trace parcels every minute of the day.</p><h4>TOOLS</h4><p>Through our PDA application your drivers will be given all the instructions daily for delivery using push tasks with customers names and addresses as well as location details. As part of the tool, you will have the option to accept these shipments or decline depending on your work load and vehicle capacity for collecting parcels from customers.</p><p>You will have access to an extranet access from the Web to monitor all the database of your daily shipments. This information is shared with the customers and our vendors to ensure timely delivery.</p><h4>QUALITY OF SERVICE</h4><p>Our engagement is the quality of service<br />– Our No 1 priority is the satisfaction of our customers<br />– The quality and representation as well as our commitment to our customers are paramount to our and your success<br />– An unparalleled teamwork towards on-time delivery<br />– Excellent customer feedback surveys and ratings</p></div>
            <h1 style={{display: 'none'}}>Become a driver</h1>
            <div id="contact_form_show" className="become_driver">
            <h4>Get Started (Submit Form)</h4><p />

            <form action="#">
        <div className="form-row row">
          <div className="form-group col-md-6">
            <label htmlFor="inputEmail4">Company Name*</label>
            <input type="text" className="form-control" id="company_name" onChange={(e)=>setformdata({...formdata,company_name:e.target.value})} placeholder="Company Name*" />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="inputPassword4">Company License No*</label>
            <input type="text" className="form-control" onChange={(e)=>setformdata({...formdata,license_no:e.target.value})} id="license_no" placeholder="Company License No*" />
          </div>
        </div>
        <div className="form-row row">
          <div className="form-group col-md-6">
            <label htmlFor="inputEmail4">Company Activities*</label>
            <input type="text" className="form-control"  onChange={(e)=>setformdata({...formdata,activities:e.target.value})} placeholder="Company Activities*" />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="inputPassword4">Transport License**</label><br/>
            <input type="radio"  onClick={(e)=>setformdata({...formdata,transport_license:'yes'})} name="transport_license" />Yes
            <input type="radio"  onClick={(e)=>setformdata({...formdata,transport_license:'no'})}  name="transport_license" />No
          </div>
        </div>
        <div className="form-row row">
          <div className="form-group col-md-6">
            <label htmlFor="inputEmail4">Contact Person*</label>
            <input type="text" className="form-control"  onChange={(e)=>setformdata({...formdata,contact_person:e.target.value})} placeholder="Contact Person*" />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="inputPassword4">Contact Number*</label>
            <input type="text" className="form-control" onChange={(e)=>setformdata({...formdata,contact_no:e.target.value})} id="license_no" placeholder="Contact Number*" />
          </div>
        </div>

        <div className="form-row row">
          <div className="form-group col-md-6">
            <label htmlFor="inputEmail4">Address*</label>
            <input type="text" className="form-control"  onChange={(e)=>setformdata({...formdata,address:e.target.value})} placeholder="Address*" />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="inputPassword4">Email*</label>
            <input type="email" className="form-control" onChange={(e)=>setformdata({...formdata,email:e.target.value})} id="license_no" placeholder="Email*" />
          </div>
        </div>

        <div className="form-row row">
          <div className="form-group col-md-6">
            <label htmlFor="inputEmail4">Country</label>
            <input type="text" className="form-control"  onChange={(e)=>setformdata({...formdata,country:e.target.value})} placeholder="Country*" />
          </div>
          <div className="form-group col-md-6">
            <label htmlFor="inputPassword4">City</label>
            <input type="text" className="form-control" onChange={(e)=>setformdata({...formdata,city:e.target.value})}  placeholder="City*" />
          </div>
        </div>
        
        
        <button type="submit" style={{marginTop:"2%",background:"purple",color:"#fff",border:"none"}} className="btn btn-primary" onClick={e => handleFormSubmit(e)}>SEND</button>
      </form>
      {resultmsg.length > 0 &&
         <p>{resultmsg}</p>
      }


            </div>

            
            
            </div>
           
            </main>
            </div>
            </div>
            </div>
            </div>
        </div>
    )
}
